import React from "react"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import type { DioboxEvent } from "sharedTypes"

type Props = {
  isOpen: boolean
  onClose: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
}

const KioskColorThemeModal = ({
  isOpen,
  onClose,
  event,
  updateEvent,
}: Props) => {
  if (!isOpen) {
    return null
  }

  return (
    <ModalForm
      title="Color Theme"
      size="xl"
      onClose={onClose}
      initialValues={{
        kioskAccentColor: event.kioskAccentColor || "#4A90E2",
      }}
      onSubmit={async (v) => {
        await updateEvent({ kioskAccentColor: v.kioskAccentColor })
        onClose()
      }}
      disableSubmitWhenNotDirty
    >
      {({ control }) => (
        <ColorSelect
          compact
          name="kioskAccentColor"
          control={control}
          description="Select the primary color used for instructions and visual highlights. If no background image is set, a gradient background will be generated based on this color."
          maxW="xs"
          labelSize="lg"
          popoverPlacement="bottom"
        />
      )}
    </ModalForm>
  )
}

export default KioskColorThemeModal
